define([
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/reflection",
	"csi/util",
	"csi/xml"
], function(def, Action, ActionFactory, reflection, util, xml) {

	return ActionFactory.declare("Copy", Action, {
		// String: default tag for action
		m_tag: "Copy",

		// Boolean: indicates if access control should be disregarded when rendering action
		bForce: false,

		// Boolean: override default rules to determine if copied node should be renamed
		forceRename: -1,

		constructor: function(obj) {
			this.bForce = util.getProperty(obj, "Force", "0") == "1";

			switch (parseInt(util.getProperty(obj, "ForceRename"), 10)) {
				case 0: this.forceRename = 0; break;
				case 1: this.forceRename = 1; break;
			}

			if (!this.m_typeControl) {
				this.setMaterialIcon('content_copy');
			}

			this.assignFormIfNecessary(util.getProperty(obj, "Form"));
			this.setBaseRights(null, xml.RIGHT_WRITE);
		},

		hasAccess: function(/*Context*/ctx) {
			// summary: disregard parent rights for now if actions is forced - they may be checked later when parent is known
			var rc = reflection.getNodeClass(ctx.getNode());
			if (rc?.abstractOrDisabled) {
				return false;
			}

			var rightParent;

			if (this.bForce) {
				rightParent = this.m_rightParent;
				this.m_rightParent = null;
			}

			var b = this.inherited(arguments);

			if (this.bForce) {
				this.m_rightParent = rightParent;
			}

			return b;
		}
	});
});